module.exports = __webpack_public_path__ + "static/helga-butcher-aba08d30970d2c514d1978bd1174a17a.jpg";